import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { TipoConvenioManutencaoRequest, TipoConvenioManutencaoResponse } from './tipo-convenio.model';

@Injectable({ providedIn: 'root' })
export class TipoConvenioService extends BaseService {
    readonly PATH = SICOM_PATHS.financeiro.arrecadacao.tipoConvenio;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    listarPorBanco(codigoBanco: string): Observable<TipoConvenioManutencaoResponse[]> {
        return this.http.get<TipoConvenioManutencaoResponse[]>(this.PATH, { params: { codigoBanco } });
    }

    salvar(request: TipoConvenioManutencaoRequest): Observable<TipoConvenioManutencaoResponse> {
        return this.http.post<TipoConvenioManutencaoResponse>(this.PATH, request);
    }

    deletar(codigoBanco: string, coTipoConvenio: number): Observable<void> {
        return this.http.delete<void>(`${this.PATH}/${codigoBanco}/${coTipoConvenio}`);
    }
}
